var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5"},[_c('a',{class:{isActive: _vm.isActive},attrs:{"href":_vm.url}},[_vm._v("打开小程序")])])
}
var staticRenderFns = []

export { render, staticRenderFns }